import { useState, useEffect } from 'react';
import { Card, Button, Modal, Form, Row, Col } from 'react-bootstrap';
import { Link, useNavigate, useParams } from 'react-router-dom';

import Layout from '../../layout/default';
import Block from '../../components/Block/Block';
import DataTable from '../../components/DataTable/DataTable';
import { Icon } from '../../components';
import { userColumns } from '../../store/categories/CategoriesData';

import Swal from "sweetalert2"
import instance, {  imageUrl, uploadInstance } from "../api"
function CategoriesList() {
    const { category_id } = useParams();
    // NEW CODE
  const [ searchText, setSearchText ] = useState("")
  // NEW CODE ENDS
    // console.log('kjkj', category_id)
    const [showModal, setShowModal] = useState(false);

    const [categoriesData, setCategoriesData] = useState([]);
    const [categoryImage, setCategoryImage] = useState(null);



    const [categoryName, setCategoryName] = useState('');
    const [, setCategoryDescription] = useState('');
    const [categoryOrder, setCategoryOrder] = useState(null);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [totalCount, setTotalCount] = useState(0);

    const [ editingCategory, setEditingCategory ] = useState(null);
    
    // NEW CODE
    const [status, setStatus] = useState('');
    const Navigate = useNavigate();
    const handleShowModal = () => setShowModal(true);

    const handleCloseModal = () => {
        setShowModal(false);
        Navigate('/categories-manage/categories-list');
        setCategoryName('');
        setCategoryDescription('');
        setCategoryOrder(null);
        setCategoryImage(null);
        setEditingCategory(null);
        setStatus('');
        setFieldErrors({
            categoryName: false,
            categoryImage:false,
            categoryDescription:false,
            categoryOrder: false,
            status: false
            
        });
    };
    const [fieldErrors, setFieldErrors] = useState({
        categoryName: false,
      
    });
    const validateForm = () => {
        const errors = {};

        if (!categoryName) {
            errors.categoryName = true;
        }
       

        setFieldErrors(errors);

        if (Object.values(errors).some((error) => error)) {
           
            return false;
        }

        return true;
    };

    const handleFileInputClick = () => {
        document.getElementById('category-image-upload-input').click();
    };

    const fetchCategoryDetails = async () => {
        try {
            const response = await instance.get(`api/Category/${category_id}`, {
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json; charset=utf-8',
                   'ngrok-skip-browser-warning':'true',
                }
            });
            const category = response.data;
            // console.log(category)
            setCategoryName(category.name || '');
            setCategoryImage(category.image || '')
            setCategoryOrder(category.sort_order || null)
            setEditingCategory(category);
            setStatus(category.status === 1 ? "Active" : "Inactive" || "");

            handleShowModal();
        } catch (error) {
            console.error('Error fetching Category details:', error);
        }
    };
    // console.log(editingCategory)
    const postCategoryData = async () => {
        if (!validateForm()) return;

        try {
            let payload;
            if (categoryImage instanceof File) {
                const formData = new FormData();
                formData.append('files', categoryImage); 

                // Debug: Check FormData content
                // for (let pair of formData.entries()) {
                //     console.log(pair[0] + ', ' + pair[1]);
                // }

                const uploadResponse = await uploadInstance.post('api/Common/Upload', formData);

                // Debug: Check upload response
                // console.log('Upload Response:', uploadResponse);

                if (uploadResponse.data.message === 'uploaded file.') {
                    payload = {
                        name: categoryName,
                        image: uploadResponse.data.file_paths,
                        sort_order: categoryOrder,
                        status: status === "Active" ? 1 : 0,
                    };
                } else {
                    throw new Error('File upload failed');
                }
            } else {
                payload = {
                    name: categoryName,
                    image: editingCategory ? editingCategory.image : null,
                    sort_order: categoryOrder,
                    status: status === "Active" ? 1 : 0,
                };
            }

            // Debug: Check payload
            // console.log('Payload:', payload);

            let categoryResponse;
            if (editingCategory) {
                categoryResponse = await instance.put(`api/Category/update/${editingCategory.category_id}`, payload);
            } else {
                categoryResponse = await instance.post('api/Category/create', payload);
            }

            // console.log("Category Response:", categoryResponse.data);

            handleCloseModal();

            const updatedResponse = await instance.get('api/Category', {
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json; charset=utf-8',
                    'ngrok-skip-browser-warning': 'true',
                },
            });

            setCategoriesData(updatedResponse.data.rows);
            Swal.fire("Success", "Category updated successfully!", "success");

            setCategoryName('');
            setCategoryImage(null);
            setCategoryDescription('');
            setCategoryOrder(null);
            setStatus('');
                } catch (error) {
            console.error('Error updating category:', error);
            Swal.fire("Error", "Failed to update Category!", "error");
        }
    };

    const handleImageUpload = (e) => {
        const file = e.target.files[0];
        // console.log('Selected File:', file);
        setCategoryImage(file);
    };
    
   
        const fetchData = async (page, pageSize) => {
            try {
                const queryParams = `page_size=${pageSize}&page=${page}` + 
                      (searchText ? `&search=${searchText}` : '');
                const response = await instance.get(
                    // `/api/Category?page_size=${pageSize}&page=${page}`
                    `/api/Category?${queryParams}`
                );
                setCategoriesData(response.data.rows);
                setTotalCount(response.data.count);

                // console.log(response.data.rows);
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };
    
      
    useEffect(() => {
        fetchData(page, rowsPerPage);
        if (category_id) {
            fetchCategoryDetails();
        }
    }, [ category_id, page, rowsPerPage, searchText ]);
    


  // NEW CODE
    const handleSearchTextChange = (text) => {
    setSearchText(text);
    };
    // NEW CODE ENDS
    

    
    const handleChangePage = (_event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        const newSize = parseInt(event.target.value, 10);
        setRowsPerPage(newSize);
        setPage(0);
    };


    const categoryColumns = userColumns({ setCategoriesData })

    return (
        <Layout title="Users List" content="container">
            <Block.Head>
                <Block.HeadBetween>
                    <Block.HeadContent>
                        <Block.Title tag="h2">Categories List</Block.Title>
                        {/* <nav>
                            <ol className="breadcrumb breadcrumb-arrow mb-0">
                                <li className="breadcrumb-item"><Link to="/home-ecommerce">Home</Link></li>
                                <li className="breadcrumb-item"><Link to="">Categories Manage</Link></li>
                                <li className="breadcrumb-item active" aria-current="page">Categories</li>
                            </ol>
                        </nav> */}
                    </Block.HeadContent>
                    <Block.HeadContent>
                        <ul className="d-flex">
                            <li>
                                <Button className="d-md-none" size="md" variant="primary" onClick={handleShowModal}>
                                    <Icon name="plus" />
                                    <span>Add</span>
                                </Button>
                            </li>
                            <li>
                                <Button className="d-none d-md-inline-flex" variant="primary" onClick={handleShowModal}>
                                    <Icon name="plus" />
                                    <span>Add Category</span>
                                </Button>
                            </li>
                        </ul>
                    </Block.HeadContent>
                </Block.HeadBetween>
            </Block.Head>

            <Block>
                <Card>
                <DataTable
                        tableClassName="data-table-head-light table-responsive"
                        data={categoriesData}
                        columns={categoryColumns}
                        searchList={['name']}
                        searchTerm='Category Name'
                        totalCount={totalCount}
                        page={page}
                        rowsPerPage={rowsPerPage}
                        onChangePage={handleChangePage}
                        onChangeRowsPerPage={handleChangeRowsPerPage}
                         // NEW ONE 
            onSearchTextChange={handleSearchTextChange}
            // NEW ONE ENDS
                    />                </Card>
            </Block>

            <Modal show={showModal} onHide={handleCloseModal}>
                <Modal.Header closeButton>
                    <Modal.Title>{editingCategory ? 'Edit Category' : 'Add Category'}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form action="#">
                        <Row className="g-3">
                            <Col lg="6">
                                <Form.Group className="form-group">
                                    <Form.Label htmlFor=" categoryName">Category Name</Form.Label>
                                    <div className="form-control-wrap">
                                        <Form.Control
                                            id=" categoryName"
                                            type="text"
                                            placeholder="Name"
                                            value={categoryName}
                                            required
                                            onChange={(e) => setCategoryName(e.target.value)}
                                            className={fieldErrors.categoryName ? 'is-invalid' : ''}
                                        />
                                    </div>
                                    {fieldErrors.categoryName && (
                            <div className="invalid-feedback">Please enter a category name.</div>
                        )}
                                </Form.Group>
                            </Col>
                      
                           
                            <Col lg="6">
                                <Form.Group className="form-group">
                                    <Form.Label htmlFor=" categoryOrder">Category Order</Form.Label>
                                    <div className="form-control-wrap">
                                        <Form.Control
                                            id=" categoryOrder"
                                            type="number" 
                                                                                        placeholder="Order"
                                            value={categoryOrder}
                                            required
                                            onChange={(e) => setCategoryOrder(e.target.value)}
                                            className={fieldErrors.categoryOrder ? 'is-invalid' : ''}
                                        />
                                    </div>
                                    {/* {fieldErrors.categoryOrder && (
                            <div className="invalid-feedback">Please enter a category order.</div>
                        )} */}
                                </Form.Group>
                            </Col>
                               {/* NEW FIELD */}
            {editingCategory && (
              <Row className="mb-3">
                <Form.Group as={Col}>
                  <Form.Label>Status</Form.Label>
                  <Form.Select
                    value={status}
                    onChange={(e) => setStatus(e.target.value)}
                    isInvalid={fieldErrors.status}
                  >
                    <option value="">Select Status</option>
                    <option value={"Active"}>Active</option>
                    <option value={"Inactive"}>Inactive </option>

                 
                  </Form.Select>
                </Form.Group>
              </Row>
            )}
                            <Col lg="6">
                                <Form.Group className="form-group">
                                    <Form.Label htmlFor="categoryImage">Category Image</Form.Label>
                                    <div className="form-control-wrap">
                                        <input
                                            id="category-image-upload-input"
                                            type="file"
                                            style={{ display: 'none' }}
                                            onChange={handleImageUpload}
                                          
                                        />
                                        <Button
                                            variant="contained"
                                            onClick={handleFileInputClick}
                                            disabled={editingCategory !== null && categoryImage === null}
                                            className={fieldErrors.categoryImage ? 'is-invalid' : ''}
                                        >
                                            Upload Image
                                        </Button>
                                        {/* {fieldErrors.categoryImage && (
                                <div className="invalid-feedback">Please upload a category image.</div>
                            )} */}
                                        {categoryImage && (
                                            <img
                                                src={categoryImage instanceof File ? URL.createObjectURL(categoryImage) : `${imageUrl}${categoryImage}`}
                                                alt=""
                                                style={{ maxWidth: '100%', maxHeight: '80px', marginTop: '10px' }}
                                            />
                                        )}

                                    </div>
                                </Form.Group>
                            </Col>
                            <Col lg="12">
                                <div className="d-flex gap g-2">
                                    <div className="gap-col">
                                        <Button variant="primary" onClick={postCategoryData}>
                                            {editingCategory ? 'Update Category' : 'Add Category'}
                                        </Button>
                                    </div>
                                    <div className="gap-col">
                                        <button type="button" className="border-0 btn" onClick={handleCloseModal}>Cancel</button>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Form>
                </Modal.Body>
            </Modal>

        </Layout>
    )
}

export const handleDeleteCategory = async (category_id, setCategoriesData) => {
    const confirmed = window.confirm('Are you sure you want to delete this category?');
    if (confirmed) {
        try {
            await instance.delete(`api/Category/delete/${category_id}`);
            // console.log(`Category with ID ${category_id} deleted successfully.`);
            Swal.fire("Success", "Category deleted successfully!", "success");

            const updatedResponse = await instance.get('api/Category', {
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json; charset=utf-8',
                   'ngrok-skip-browser-warning':'true',
                }
            });
            setCategoriesData(updatedResponse.data.rows);
        } catch (error) {
            console.error(`Error deleting category with ID ${category_id}:`, error);
            Swal.fire("Error", "Failed to delete Category!","error");


            console.error(error.response);
            console.error(error.message);
        }
    }
};
export const handleToggleEnable = async (category_id, currentStatus, setCategoriesData) => {
    const confirmed = window.confirm(`Are you sure you want to ${currentStatus ? 'disable' : 'enable'} this category?`);
    
    if (confirmed) {
        try {
            const updatedStatus = !currentStatus;

           
            await instance.put(`api/Category/update/${category_id}`, {
                is_enable: updatedStatus,
            });

            // console.log(`Category with ID ${category_id} ${updatedStatus ? 'disabled' : 'enabled'} successfully.`);
            
         
            const updatedResponse = await instance.get('api/Category');
            setCategoriesData(updatedResponse.data.rows);
        } catch (error) {
            console.error(`Error toggling enable status for category with ID ${category_id}:`, error);

        }
    }
};


export default CategoriesList;